import { OrderReleasesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class OrderReleaseService {
  httpClient = createApiClient(OrderReleasesApi)

  async getReleasesByReferenceNumber(referenceNumber: string) {
    const { data } = await this.httpClient.get(referenceNumber)
    return data
  }
}

const orderReleaseService = new OrderReleaseService()

export default orderReleaseService
